import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import OptionsChainPicker from "../components/OptionsChainPicker";
import BalancesCard from "../components/BalancesCard";
import PlaceOptionOrderCard from "../components/PlaceOptionOrderCard2";

export default function OptionsSearchPage() {
    const userId = localStorage.getItem("trader_id");
    const [sel, setSel] = useState(null);

    // 🔥 NEW: read ?ticker=XYZ from URL
    const location = useLocation();
    const [initialTicker, setInitialTicker] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const symbol = params.get("ticker");
        if (symbol) {
            setInitialTicker(symbol.toUpperCase());
        }
    }, [location.search]);

    return (
        <div className="p-6 grid gap-6 lg:grid-cols-3">
            <h2 className="text-xl font-semibold lg:col-span-3">
                Options Chain Picker
            </h2>

            <div className="space-y-6 lg:col-span-2">
                <BalancesCard userId={userId} />

                {/* 🔥 Pass initialTicker so OptionsChainPicker autofills */}
                <OptionsChainPicker
                    userId={userId}
                    onSelect={setSel}
                    initialTicker={initialTicker}
                />

                <PlaceOptionOrderCard userId={userId} selection={sel} />
            </div>
        </div>
    );
}
